import React, { FunctionComponent } from 'react'

import styled from 'styled-components/native'

import { useMediaQuerySize } from '../../hooks/useMediaQuerySize'
import { tID } from '../../utils'
import { Image } from '../image/Image'

type ContactCareNavigatorIllustrationProps = {
  desktopWidth?: number
  desktopHeight?: number
  mobileWidth?: number
  mobileHeight?: number
}

const Illustration = styled(Image)<{
  width: number
  height: number
}>(({ width, height }) => ({
  width: `${width}px`,
  height: `${height}px`,
}))

export const ContactCareNavigatorIllustration: FunctionComponent<ContactCareNavigatorIllustrationProps> = ({
  desktopWidth = 282,
  desktopHeight = 179,
  mobileWidth = 244,
  mobileHeight = 155,
}) => {
  const { isMobileSized } = useMediaQuerySize()
  const testID = tID('ContactCareNavigatorIllustration')

  return isMobileSized ? (
    <Illustration
      source={require('../../assets/contact_CN_mobile.png')}
      contentFit='contain'
      accessibilityIgnoresInvertColors
      width={mobileWidth}
      height={mobileHeight}
      testID={testID}
    />
  ) : (
    <Illustration
      source={require('../../assets/contact_CN_desktop.png')}
      contentFit='contain'
      accessibilityIgnoresInvertColors
      width={desktopWidth}
      height={desktopHeight}
      testID={testID}
    />
  )
}
